import { SortCondition } from 'shared/enums';
import { TVacationInfo } from 'shared/types/vacations.types';
import { edpApiV1 } from './index';

export type VacationsRequest = {
  type: string | null;
  size?: number | null;
  page?: number | null;
  order?: SortCondition;
  allAvailableOrganizations: boolean;
};

export type VacationsResponse = {
  data: TVacationInfo[] | null;
  pagination: {
    size: number;
    page: number;
    total: number;
  } | null;
};

export type ChangeResponsible = {
  requestId?: number | string;
  hrId: number;
};

export type RejectVacationRequest = {
  requestId?: number;
  rejectionReason: string;
};

export const vacationsApi = edpApiV1.injectEndpoints({
  endpoints: build => ({
    vacations: build.query<VacationsResponse, VacationsRequest>({
      query: payload => ({ url: '/v1/admin/hr/vacation-application/requests', method: 'GET', params: payload }),
      providesTags: ['vacations'],
    }),
    singleVacation: build.query<TVacationInfo, { requestId: number | string; allAvailableOrganizations: boolean }>({
      query: ({ requestId, ...params }) => ({
        url: `/v1/admin/hr/vacation-application/requests/${requestId}`,
        method: 'GET',
        params,
      }),
      providesTags: ['singleVacation'],
    }),
    changeResponsible: build.mutation<unknown, ChangeResponsible>({
      query: ({ requestId, ...body }) => ({
        url: `/v1/admin/hr/vacation-application/requests/${requestId}/change-responsible`,
        method: 'POST',
        body,
      }),
      invalidatesTags: ['vacations', 'singleVacation'],
    }),
    approveVacation: build.mutation<unknown, string>({
      query: reqiestId => ({ url: `/v1/admin/hr/vacation-application/requests/${reqiestId}/approve`, method: 'POST' }),
      invalidatesTags: ['vacations', 'singleVacation'],
    }),
    rejectVacation: build.mutation<unknown, RejectVacationRequest>({
      query: ({ requestId, ...body }) => ({
        url: `/v1/admin/hr/vacation-application/requests/${requestId}/reject`,
        method: 'POST',
        body,
      }),
      invalidatesTags: ['vacations', 'singleVacation'],
    }),
    takeToWork: build.mutation<unknown, ChangeResponsible>({
      query: ({ requestId, ...body }) => ({
        url: `/v1/admin/hr/vacation-application/requests/${requestId}/take-to-work`,
        method: 'POST',
        body,
      }),
      invalidatesTags: ['vacations'],
    }),
    vacationDownload: build.query<string, { type: string }>({
      query: payload => ({
        url: '/v1/admin/hr/vacation-application/requests/download-file',
        method: 'GET',
        params: payload,
        responseHandler: async response => {
          const link = document.createElement('a');
          link.download = 'vacations';
          link.href = window.URL.createObjectURL(await response.blob());
          link.click();
        },
      }),
    }),
  }),
  overrideExisting: false,
});

export const {
  useVacationsQuery,
  useLazyVacationsQuery,
  useLazySingleVacationQuery,
  useRejectVacationMutation,
  useApproveVacationMutation,
  useChangeResponsibleMutation,
  useTakeToWorkMutation,
  useLazyVacationDownloadQuery,
} = vacationsApi;
